export default __webpack_public_path__ + "static/media/Wolfram.0401009d.svg";